import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Toaster } from 'sonner';
import { AppRoutes } from './routes/AppRoutes';
import { useAuth } from '@features/auth/AuthProvider';
const SplashScreen = () => (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-neutral-100", children: _jsxs("div", { className: "flex flex-col items-center gap-4 text-neutral-500", children: [_jsx("div", { className: "h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" }), _jsx("p", { className: "text-sm font-medium", children: "Carregando WalletHub\u2026" })] }) }));
function App() {
    const { isBootstrapping } = useAuth();
    if (isBootstrapping) {
        return _jsx(SplashScreen, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(Suspense, { fallback: _jsx(SplashScreen, {}), children: _jsx(AppRoutes, {}) }), _jsx(Toaster, { richColors: true, position: "top-right" })] }));
}
export default App;
